import { ConfigurationSummaryModalEnum } from '@inter-ikea-kompis/component-configuration-summary';
import { FinancialServicesModalEnum } from '@inter-ikea-kompis/component-financial-services';
import { SaveDesignToProfileModalEnum } from '@inter-ikea-kompis/component-save-design-to-profile';
import { SortListModalEnum } from '@inter-ikea-kompis/component-sort-list';
import { StoreSelectorModalEnum } from '@inter-ikea-kompis/component-store-selector';
import { ZipInModalEnum } from '@inter-ikea-kompis/component-zip-in';

enum SummaryPageModalEnum {
	confirmationCard = ConfigurationSummaryModalEnum.confirmationCard,
	ecoFeeCard = ConfigurationSummaryModalEnum.ecoFeeCard,
	energyFicheCard = ConfigurationSummaryModalEnum.energyFicheCard,
	energyLabelCard = ConfigurationSummaryModalEnum.energyLabelCard,
	unavailableProductCard = ConfigurationSummaryModalEnum.unavailableProductCard,
	storeSelectorCard = StoreSelectorModalEnum.storeSelectorCard,
	shareDesignCard = ConfigurationSummaryModalEnum.shareDesignCard,
	buyInStore = ConfigurationSummaryModalEnum.buyInStore,
	financialServicesCard = FinancialServicesModalEnum.financialServicesCard,
	sortListCard = SortListModalEnum.sortListCard,
	saveDesignToProfileCard = SaveDesignToProfileModalEnum.saveDesignToProfileCard,
	zipIn = ZipInModalEnum.zipIn
}

export default SummaryPageModalEnum;
